import { checklistApis } from '@apis/checklistApis';
import { useQuery } from '@hooks/useQuery';

export const useChecklist = () => {
  return useQuery(['/company/checklist/'], () =>
    checklistApis.get('/company/checklist/', {}).then((r) => r[200]!),
  );
};
